<template>
  <div class="evn-detail" v-if="envDetail">
    <div class="evn-left">
      <p class="title">
        <span class="tit" @click="$router.push({ name: 'environment' })">环境库</span><span> - {{ envDetail.name }}</span>
      </p>
      <div class="evn-left-top">
        <div class="icon">
          <img :src="envDetail.icon" />
        </div>
        <p class="name">{{ envDetail.name }}</p>
        <div class="des">{{ envDetail.description }}</div>
        <div class="env-info">
          <div class="datas">
            <span class="tit">区块高度</span>
            <span class="num">{{ toThousands(envDetail.blocks) }}</span>
          </div>
          <div class="datas">
            <span class="tit">交易数量</span>
            <span class="num">{{ toThousands(envDetail.transactions) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="evn-right">
      <div class="evn-right-top">
        <ul>
          <li :class="tab === 1 ? 'active' : ''" @click="changeTab(1)">工具</li>
          <li :class="tab === 2 ? 'active' : ''" @click="changeTab(2)">文档</li>
          <li :class="tab === 3 ? 'active' : ''" @click="changeTab(3)">资源</li>
          <li :class="tab === 4 ? 'active' : ''" @click="changeTab(4)">案例</li>
        </ul>
      </div>
      <div class="evn-right-bottom">
        <div class="bgc" v-if="tab === 1">
          <ul class="tab1">
            <li v-for="(item, index) in toolList" :key="index" @click="goTool(item.note)">
              <div class="icon">
                <img :src="item.icon" />
              </div>
              <div class="word">
                <Tooltip :content="item.name" theme="light">
                  <span class="name">{{ item.name }}</span>
                </Tooltip>
                <span class="version">{{ item.version }}</span>
                <span class="des">{{ item.description }}</span>
              </div>
            </li>
            <div v-if="toolList.length == 0" class="noData">暂无数据</div>
          </ul>
        </div>
        <div class="bgc" v-if="tab === 2">
          <ul class="tab1 tab2">
            <li v-for="(item, index) in envFile" :key="index" @click="goFile(item.url)">
              <div class="icons" v-for="(items, index1) in fileType" :key="index1">
                <Img v-if="item.kind === items.kind" :src="items.icon" />
              </div>
              <div class="word">
                <Tooltip :content="item.name" theme="light">
                  <span class="name">{{ item.name }}</span>
                </Tooltip>
                <span class="des">{{ item.description }}</span>
              </div>
            </li>
            <div v-if="envFile.length == 0" class="noData">暂无数据</div>
          </ul>
        </div>
        <ul v-if="tab === 3" class="bgcfff tab3-all">
          <div v-if="resourcesList.length == 0" class="noData">暂无数据</div>
          <div class="tab3" v-for="(item, index) in resourcesList" :key="index">
            <p class="title">{{ item.name }}</p>
            <p class="des">{{ item.describe }}</p>
            <p class="nav">
              <a :href="item.linkUrl" target="block" class="name">{{ item.linkUrl }}</a
              ><span class="date">{{ item.date ? parseTime(item.date) : '' }}</span>
            </p>
          </div>
        </ul>
        <ul v-if="tab === 4" class="tab4">
          <div v-if="caseList.length == 0" class="noData">暂无数据</div>
          <div class="section-list">
            <div
              class="section"
              v-for="(item, index) in caseList"
              :key="index"
              @click="
                $router.push({
                  name: 'case_detail',
                  query: { id: item.id, env_id: item.chain_env_id }
                })
              "
            >
              <div class="section-top">
                <ul class="title">
                  {{
                    item.name
                  }}
                </ul>
                <ul class="author">
                  作者：{{
                    item.author ? item.author : '智谷星图'
                  }}
                </ul>
                <ul class="type-tag">
                  <li v-if="item.code_link">
                    <Img src="/icon-case-code.png" />
                    <span>代码</span>
                  </li>
                  <li v-if="item.show_link">
                    <Img src="/icon-case-yanshi.png" />
                    <span>演示</span>
                  </li>
                  <li v-if="item.parse_link">
                    <Img src="/icon-case-jiexi.png" />
                    <span>解析</span>
                  </li>
                </ul>
                <ul class="tap">
                  <li v-for="items in item.tags" :key="items">#{{ items }}</li>
                </ul>
              </div>
            </div>
          </div>
          <Page v-if="total > 0 && tab === 4" :total="total" @on-change="pageChange" show-total />
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Img from '../../components/Img.vue'
import { Tooltip, Page } from 'view-design'
export default {
  components: { Img, Tooltip, Page },
  data() {
    return {
      tab: 1,
      toolList: [],
      resourcesList: [],
      caseList: [],
      envFile: [],
      active: 0,
      total: 0,
      queryParams: {
        size: 10,
        page: 1
      },
      fileType: [
        { kind: 1, icon: '/pdf.png' },
        { kind: 2, icon: '/ppt.png' },
        { kind: 3, icon: '/word.png' },
        { kind: 4, icon: '/excel.png' }
      ], //文档类型，1:pdf, 2:ppt, 3:word, 4:xlsx
      envAttribute: undefined,
      envDetail: undefined
    }
  },
  created() {
    this.getEnvDetail()
    this.getEnvAttribute()
    this.getToolList()
    if (+this.$route.query.tab === 4) {
      this.tab = 4
      this.getCaseList()
    }
  },
  methods: {
    pageChange(page) {
      this.queryParams.page = page
      this.getCaseList()
    },
    changeTab(index) {
      this.tab = index
      if (this.tab === 2) {
        this.getEnvfile()
      } else if (this.tab === 3) {
        this.getEnvResource()
      } else if (this.tab === 4) {
        this.queryParams.page = 1
        this.getCaseList()
      }
    },
    openDemo(item) {
      window.open(item.show_link, 'demo')
    },
    // 获取环境详情
    async getEnvDetail() {
      const params = {
        uriCode: 'API011',
        bindVars: [
          {
            key: 'id',
            value: this.$route.params.id
          }
        ]
      }
      const res = await this.$fetch(params)
      this.envDetail = res
    },
    //获取环境下的案例列表
    async getCaseList() {
      const params = {
        uriCode: 'API020',
        chain_env_id: this.$route.params.id,
        ...this.queryParams
      }
      const res = await this.$fetch(params)
      this.caseList = res.list || []
      this.total = res.total_record
      this.loading = false
    },
    // 获取环境属性
    async getEnvAttribute() {
      const params = {
        uriCode: 'API012',
        envId: this.$route.params.id
      }
      const res = await this.$fetch(params)
      this.envAttribute = res
    },
    // 获取环境文档
    async getEnvfile() {
      const params = {
        uriCode: 'API018',
        envId: this.$route.params.id
      }
      const res = await this.$fetch(params)
      this.envFile = res.list
    },
    // 获取环境资源
    async getEnvResource() {
      const params = {
        uriCode: 'API019',
        envId: Number(this.$route.params.id),
        pageIndex: 1,
        pageSize: 30
      }
      const res = await this.$fetch(params)
      this.resourcesList = res.list
    },
    // 下载文档
    goFile(url) {
      window.open(url)
    },
    // 跳转工具
    goTool(toolLink) {
      window.open(toolLink)
    },
    // 获取工具列表
    async getToolList() {
      const params = {
        uriCode: 'API009',
        envId: this.$route.params.id,
        limit: 16,
        page: 1
      }
      const res = await this.$fetch(params)
      this.toolList = res.list
    }
  }
}
</script>

<style scoped lang="scss">
.evn-detail {
  display: flex;
  flex-direction: row;

  .evn-left {
    width: 377px;
    // min-height: 660px;
    height: calc(100vh - 80px);
    margin-top: 10px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    margin-right: 10px;
    box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.08);
    border-radius: 8px;

    &-top {
      height: calc(100vh - 116px);
      overflow-y: auto;
    }

    .title {
      margin: 11px 0 0 20px;
      font-size: 16px;
      color: #505050;
      line-height: 25px;

      .tit {
        color: #262626;
        cursor: pointer;
        font-weight: 600;
      }
    }

    .icon {
      margin: 36px 0 17px 0;
      text-align: center;

      img {
        border-radius: 50% !important;
        width: 60px;
        height: 60px;
        background-color: #4c94ef;
      }
    }

    .name {
      text-align: center;
      font-weight: 600;
      color: #262626;
      line-height: 25px;
      font-size: 16px;
    }

    .des {
      width: 346px;
      // min-height: 220px;
      max-height: 420px;
      line-height: 26px;
      margin: 10px auto;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      text-align: justify;
      -webkit-box-orient: vertical;
      overflow: auto;
      box-sizing: border-box;
      padding: 0 6px;
    }
  }

  .evn-right {
    width: 1053px;
    flex: 1;
    display: flex;
    flex-direction: column;

    .evn-right-top {
      height: 40px;
      line-height: 40px;
      margin-top: 10px;
      width: 100%;
      border-radius: 6px;
      background-color: #fff;

      ul {
        display: flex;

        li {
          color: #333;
          font-size: 16px;
          cursor: pointer;
          margin-right: 52px;

          &:first-child {
            margin: 0 52px 0 37px;
          }
        }

        li.active {
          font-weight: 600 !important;
        }
      }
    }

    .evn-right-bottom {
      width: 100%;
      margin-top: 10px;

      ::-webkit-scrollbar-track {
        background-color: #eeeeee !important;
        box-shadow: none !important;
      }

      .bgc {
        // min-height: 600px;
        background-color: #fff;
        border-radius: 8px;
        height: calc(100vh - 130px);
        overflow-y: auto;

        ul {
          display: flex;
          flex-wrap: wrap;
        }
      }

      .noData {
        color: #999;
        text-align: center;
        line-height: 60px;
        margin: auto;
      }

      .tab1 {
        margin-top: 10px;

        box-sizing: border-box;
        padding: 0 10px;
        width: 100%;

        li:hover {
          box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
        }

        li {
          margin-bottom: 0 !important;
          box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.07);
          width: 250px;
          height: 120px;
          cursor: pointer;
          margin: 10px 10px 0 0px;
          background-color: #fff;
          box-sizing: border-box;
          padding: 9px;
          display: flex;
          position: relative;
          flex-wrap: nowrap;

          &:nth-child(4n) {
            margin-right: 0px !important;
            margin-left: 2px;
          }

          .version {
            color: #999999;
            line-height: 20px;
            font-size: 14px;
            position: absolute;
            right: 18px;
            top: 36px;
          }

          .icon {
            display: flex;
            align-items: center;

            img {
              width: 43px;
              height: 43px;
              margin-right: 10px;
              border-radius: 50%;
            }
          }

          .icons {
            img {
              width: 43px;
              height: 43px;
              margin-right: 10px;
            }
          }

          .word {
            display: flex;
            flex-direction: column;

            .ivu-tooltip {
              margin-top: 26px;
            }

            .name {
              color: #333;
              font-size: 16px;
              font-weight: 600;
              width: 120px !important;
              display: inline-block;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .des {
              width: 176px;
              font-size: 14px;
              line-height: 20px;
              color: #666;
              height: 40px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              /*超出部分文字以...显示*/
            }
          }
        }
      }

      .tab2 {
        margin-top: 10px;
        display: flex;
        box-sizing: border-box;
        padding: 0 11px 10px 11px;

        li:hover {
          box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.1);
        }

        li {
          align-items: center;
          box-shadow: 0px 3px 10px 0px rgba(0, 0, 0, 0.07);

          &:nth-child(3n) {
            margin-right: 0px;
          }

          &:nth-child(4n) {
            margin-right: 9px !important;
            margin-left: 0px;
          }

          width: 337px;
          height: 120px;

          .word {
            width: 270px;

            .name {
              display: inline-block;
              width: 270px !important;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .des {
              width: 270px;
              font-size: 14px;
              line-height: 20px;
              color: #666;
              height: 40px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-overflow: ellipsis;
              /*超出部分文字以...显示*/
            }
          }

          .ivu-tooltip {
            margin-top: 26px !important;
          }
        }

        .icons {
          img {
            width: 27px !important;
            height: 30px !important;
            margin-right: 10px;
          }
        }
      }

      .bgcfff {
        width: 1053px;
        background-color: #fff;
        // max-height: 650px;
        flex-wrap: wrap;
        overflow: hidden auto;
      }

      .tab3-all {
        height: calc(100vh - 130px) !important;
        overflow-y: auto;
      }

      .tab3 {
        margin: 22px 39px 0 39px;
        border-bottom: 1px solid #eeeeee;
        padding: 22px 0;
        box-sizing: border-box;
        width: 975px;

        .title {
          font-size: 16px;
          font-weight: 600;
        }

        .des {
          margin-top: 20px;
          font-size: 14px;
          color: #666;
        }

        .nav {
          margin-top: 20px;
          display: flex;
          flex-direction: row;
          line-height: 22px;

          .name {
            color: #468fef;
            text-decoration: underline;
            font-size: 14px;
          }

          .date {
            margin-left: 6px;
            font-size: 14px;
            font-weight: 600;
            color: #333;
          }
        }
      }

      .tab4 {
        padding: 20px;
        background-color: #fff;
        height: calc(100vh - 130px);
        overflow-y: auto;
        display: flex;
        flex-direction: column;

        :nth-child(3n).section {
          margin-right: 0;
        }
        .section-list {
          height: calc(100vh - 153px);
        }

        .section:hover {
          box-shadow: 0px 8px 16px 0px rgba(96, 97, 112, 0.16), 0px 2px 4px 0px rgba(40, 41, 61, 0.04);
        }

        .section {
          border-radius: 10px;
          border: 1px solid rgba(28, 42, 52, 0.1);
          width: 322px;
          margin: 0 20px 20px 0;
          box-sizing: border-box;
          float: left;
          height: 200px;
          cursor: pointer;
          transition: all 0.4s ease-in-out;

          &-top {
            padding: 20px;
          }

          .title {
            font-size: 18px;
            font-weight: 600;
            color: #1c2a34;
            line-height: 25px;
            width: 282px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .author {
            margin-top: 10px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(28, 42, 52, 0.45);
            line-height: 22px;
            width: 282px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .tap {
            margin-top: 16px;
            height: 54px;
            display: flex;
            flex-wrap: wrap;

            li {
              font-size: 14px;
              font-weight: 400;
              color: #468fef;
              line-height: 22px;
              height: 22px;
              border-radius: 12px;
              background-color: rgba(70, 143, 239, 0.05);
              padding: 0 10px;
              margin-right: 10px;
              margin-bottom: 10px;
            }
          }

          .type-tag {
            line-height: 20px;
            height: 20px;
            margin-top: 10px;

            img {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }

            display: flex;
            flex-wrap: nowrap;

            li {
              font-size: 14px;
              font-weight: 400;
              color: rgba(28, 42, 52, 0.65);
              text-align: center;
              margin-right: 20px;
            }
          }
        }
      }
    }
  }
}

.env-info {
  width: 100%;
  margin: 0 auto;
  margin-top: 22px;
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  padding: 0 20px;
  justify-content: space-between;

  .datas {
    // width: 40%;
    display: flex;
    flex-direction: column;
    text-align: left;

    .tit {
      color: #333333;
      line-height: 22px;
      font-size: 16px;
    }

    .num {
      font-weight: 900;
      color: #468fef;
      line-height: 33px;
      font-family: Arial-Black !important;
      font-size: 24px;
    }
  }
}
</style>
